import React from "react";
import "./Help.css";
import { 
  FaUserShield, FaCheckCircle, FaEye, FaPhoneAlt, FaHandsHelping, FaShieldAlt 
} from "react-icons/fa";

const HelpTrustSafety = () => {
  return (
    <section className="helpSection p-3">
      <div className="container-xl">
        <div className="helpHeader mb-4">
          <h2 className="fw-bold text-dark">Trust & Safety</h2>
          <p className="text-muted">
            Your peace of mind is our top priority. Learn how YOVHO ensures secure, safe, and worry-free stays.
          </p>
        </div>

        <div className="helpContent">

          {/* 1 */}
          <div className="helpItem">
            <div className="helpIcon"><FaUserShield /></div>
            <div className="helpText">
              <h5>Safety of Guests & Foreign Travelers</h5>
              <p>
                YOVHO prioritizes your safety. We ensure all verified properties maintain a secure environment for solo travelers, families, and corporate guests. Special attention is given to foreign visitors to make them feel at home.
              </p>
            </div>
          </div>

          {/* 2 */}
          <div className="helpItem">
            <div className="helpIcon"><FaCheckCircle /></div>
            <div className="helpText">
              <h5>Verified & Legally Registered Properties</h5>
              <p>
                YOVHO partners only with properties that are fully verified by local authorities, legally registered, and bound by court-registered agreements to meet strict safety standards.
              </p>
            </div>
          </div>

          {/* 3 */}
          <div className="helpItem">
            <div className="helpIcon"><FaEye /></div>
            <div className="helpText">
              <h5>Surprise Property Inspections</h5>
              <p>
                Our trained teams conduct unannounced weekly inspections to assess cleanliness, staff professionalism, emergency readiness, and neighborhood safety.
              </p>
            </div>
          </div>

          {/* 4 */}
          <div className="helpItem">
            <div className="helpIcon"><FaShieldAlt /></div>
            <div className="helpText">
              <h5>Guest Privacy & Booking Security</h5>
              <p>
                All bookings are handled securely. Your personal information and travel details are protected at every step—from search to check-out.
              </p>
            </div>
          </div>

          {/* 5 */}
          <div className="helpItem">
            <div className="helpIcon"><FaPhoneAlt /></div>
            <div className="helpText">
              <h5>24/7 Emergency Support</h5>
              <p>
                Every guest receives access to a dedicated emergency helpline available 24/7. Whether it’s urgent help or advice, our support team is always just one call away.
              </p>
            </div>
          </div>

          {/* 6 */}
          <div className="helpItem">
            <div className="helpIcon"><FaHandsHelping /></div>
            <div className="helpText">
              <h5>Clean, Hygienic & Traveler-Friendly Locations</h5>
              <p>
                We select safe, accessible, and welcoming locations. Every property meets standards for sanitation, professional staff behavior, and comfortable, respectful environments.
              </p>
            </div>
          </div>

          {/* 7 */}
          <div className="helpItem">
            <div className="helpIcon"><FaCheckCircle /></div>
            <div className="helpText">
              <h5>What Makes YOVHO Different?</h5>
              <ul>
                <li>Only government-verified & legally approved properties</li>
                <li>Transparent operations with formal legal agreements</li>
                <li>Weekly quality checks without notice</li>
                <li>Clean, safe, traveler-friendly accommodations</li>
                <li>Private and secure booking system</li>
                <li>24/7 emergency support line</li>
              </ul>
            </div>
          </div>

          {/* 8 */}
          <div className="helpItem">
            <div className="helpIcon"><FaHandsHelping /></div>
            <div className="helpText">
              <h5>Our Team & On-Site Support</h5>
              <p>
                Our dedicated team and local captains are always available—over a call or on-site. From check-in support to last-minute requests, we ensure a smooth, safe, and comfortable experience.
              </p>
            </div>
          </div>

        </div>
      </div>
    </section>
  );
};

export default HelpTrustSafety;
